import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Subscriber {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  getNotifList(params?: any){
    return this.api.get('index.php/subscribe/notifList', params);
  }
 
  getTenderSubscribers(params?: any){
    return this.api.get("index.php/subscribe", params);
  }

  addSubscriber(params?: any){
    return this.api.post("index.php/subscribe", params);
  }
  
  getSubscribeStatus(params?: any){
    return this.api.get("index.php/subscribe", params);
  }

  getEmployee(params?: any){
    return this.api.get("index.php/subscribe/employee", params);
  }

  deleteNotif(params?: any){
    return this.api.post("index.php/subscribe/notifList", params);
  }


}


// WEBPACK FOOTER //
// ./src/providers/marketing/subscriber/subscriber.ts